import React from 'react';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';

import {styles} from './HighestAchievedRank.style';

interface HighestAchievedRankItem {
  highestAchievedRank: {
    description: string;
  };
}

interface HighestAchievedRankProps {
  tt: (key: string, callback: any) => any;
  item?: HighestAchievedRankItem | null;
}

export const HighestAchievedRank: React.FC<HighestAchievedRankProps> = ({
  tt = withTranslation.ttDefaultProp,
  item = null,
}: HighestAchievedRankProps) => {
  const highestAchievedRankDescription = get(
    item,
    'highestAchievedRank.description',
    '',
  );

  return tt(
    'rank',
    generateComponentCallback({
      component: (
        <Text testID={Reports.reportHraRank}>
          <Text style={styles.rankLabel}>HRA</Text>{' '}
          {highestAchievedRankDescription}
        </Text>
      ),
    }),
  );
};

export default withTranslation('report.record.highestAchievedRank')(
  HighestAchievedRank,
);
